// Route patterns and the helpers that build them, kept together so a link can
// never drift from the route it targets.

import type { ChurchService } from "./model/launchpad";

/**
 * A service is addressed by its church as well as its own id: the backend
 * requires the churchID to fetch a service, so the URL has to carry it.
 */
export const SERVICE_DETAIL_ROUTE = "/church/:churchID/service/:serviceID";

export function serviceDetailPath(service: Pick<ChurchService, "churchID" | "id">): string {
  return `/church/${encodeURIComponent(service.churchID)}/service/${encodeURIComponent(service.id)}`;
}
